var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import sort, { ESortOrder, stringSort, dateSort, ratingSort, } from "@domains/utils/sort";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
import { addCommas } from "@domains/utils/numberMethods";
var CommonPresenter = /** @class */ (function () {
    function CommonPresenter(usecase, actions, useCasesStream) {
        var _this = this;
        this.usecase = usecase;
        this.actions = actions;
        this.useCasesStream = useCasesStream;
        this.symbol = [];
        this.streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
            streamKeys[4],
            streamKeys[5],
            streamKeys[15],
            streamKeys[16],
        ];
        this.clearScripDetails = function () {
            _this.actions.scripDetailActions.getScripDetailData({});
            _this.symbol = [];
            _this.actions.scripDetailActions.stopLoader();
        };
    }
    CommonPresenter.prototype.verifyMsLogin = function (code) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.verifyMsLogin.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, code);
        });
    };
    CommonPresenter.prototype.activeScreen = function (active) {
        this.useCasesStream.activeScreen(active);
    };
    CommonPresenter.prototype.getScripDetailData = function (req) {
        var _this = this;
        this.actions.scripDetailActions.hideError();
        this.actions.scripDetailActions.startLoader();
        this.actions.scripDetailActions.clearData();
        this.usecase.scripDetail.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.scripDetailActions.getScripDetailData(data);
                    _this.symbol = [req.symbol];
                }
                _this.actions.scripDetailActions.stopLoader();
            },
            onError: function (error) {
                _this.actions.scripDetailActions.setError({ isOpen: true, error: error });
                _this.actions.scripDetailActions.stopLoader();
            },
        }, req);
    };
    CommonPresenter.prototype.scriptDetailsStreaming = function (subscribe) {
        var _this = this;
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.actions.scripDetailActions.getScriptDetailStreamData(data);
                return [2 /*return*/];
            });
        }); }, this.symbol, this.streamMapKey, StreamingSectionName.Common_SideBar);
    };
    CommonPresenter.prototype.marketDepthStreaming = function (subscribe, cb) {
        var _this = this;
        this.useCasesStream.streamQuote(STREAMING_TYPE.QUOTE2, subscribe, cb
            ? cb
            : function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (this.symbol.includes(data.symbol)) {
                        this.actions.scripDetailActions.getMarketDepthStreamData(data);
                    }
                    return [2 /*return*/];
                });
            }); }, this.symbol, [], StreamingSectionName.Market_Depth_Common_SideBar);
    };
    CommonPresenter.prototype.portalAccessLogin = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.portalAccessLogin.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    CommonPresenter.prototype.portalAccessOtpValidate = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.portalAccessOtpValidate.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    CommonPresenter.prototype.portalAccessResendOtp = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.portalAccessResendOtp.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    CommonPresenter.prototype.getSortedData = function (data, type, key, dataType) {
        var sortType = type ? ESortOrder.ASC : ESortOrder.DESC;
        if (dataType === "string") {
            return stringSort(data, key, sortType);
        }
        else if (dataType === "Date")
            return dateSort(data, key, sortType);
        else if (dataType === "Rating")
            return ratingSort(data, key, sortType);
        else if (dataType === "numberWithComma")
            return sort(data.map(function (x) {
                var _a;
                if (x[key] === "-" ||
                    x[key] === "" ||
                    x[key] === null ||
                    x[key] === undefined)
                    return x;
                return __assign(__assign({}, x), (_a = {}, _a[key] = parseFloat(x[key].replace(/,/g, "")), _a));
            }), key, sortType).map(function (x) {
                var _a;
                return __assign(__assign({}, x), (_a = {}, _a[key] = addCommas(x[key]), _a));
            });
        return sort(data, key, sortType);
    };
    CommonPresenter.prototype.readConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.customConfig.execute({
                            onSuccess: function (configuration) {
                                resolve(configuration);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, null);
                    })];
            });
        });
    };
    CommonPresenter.prototype.returnScriptData = function (req) {
        var _this = this;
        return new Promise(function (res, rej) {
            _this.usecase.scripDetail.execute({
                onSuccess: function (data) {
                    if (data) {
                        res(data);
                        _this.symbol = [req.symbol];
                    }
                },
                onError: function (error) {
                    rej({ isOpen: true, error: error });
                },
            }, req);
        });
    };
    return CommonPresenter;
}());
export default CommonPresenter;
